import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { ExpertLayout } from '../ExpertLayout';
import { ExpertEntities } from "../ExpertEntities";
import { ExpertRouterProps } from "../ExpertRouterProps";

interface AgentViewPageProps extends NSARouterMakerResult, ExpertRouterProps { }

export default class AgentViewPage extends Component<AgentViewPageProps>
{
    override render()
    {
        return (
            <ExpertLayout
                {...this.props}
                pages={{
                    entity: ExpertEntities.agent(this.props),
                    view: {}
                }}
            >
                <></>
            </ExpertLayout>
        );
    }
}